import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0075eef5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "data-inconsistency__count-line" };
const _hoisted_2 = { "data-cy": "data-inconsistency-count-line" };
import { toRefs } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistencyCountLine',
    props: {
        countLine: {},
        totalCount: {}
    },
    setup(__props) {
        const props = __props;
        const { countLine } = toRefs(props);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('integrations.data-inconsistency.count-line', { lines: _unref(countLine), totalLines: _ctx.totalCount })), 1)
            ]));
        };
    }
});
